<!-- =========================================================================================
    File Name: ApkDownload.vue
    Description: App Download page
========================================================================================== -->

<template>
    <div id="demo-basic-card">
        
        <p class="text-danger font-bold mb-5"> 
            <feather-icon icon="HashIcon" svgClasses="w-5 h-5" class="edit-icon text-danger font-bold mb-5" />
            {{this.$t('VERSION_CHANGE_WARNING_MESSAGE')}}
        </p>
        <div class="vx-row">
           <div class="vx-col w-1/3 md:w-1/3 xl:w-1/3">
                <version-card
                  hideChart
                  class="mb-base"
                  icon="SmartphoneIcon"
                  :statistic="androidAppVersion"
                  :statisticTitle="'ANDROID_APP_VERSION'" />
            </div>
            <div class="vx-col w-1/3 md:w-1/3 xl:w-1/3">
                <version-card
                  hideChart
                  class="mb-base"
                  icon="SmartphoneIcon"
                  :statistic="iosAppVersion"
                  :statisticTitle="'IOS_APP_VERSION'"
                  color='danger'  />
            </div>
            <div class="vx-col w-1/3 md:w-1/3 xl:w-1/3">
                <version-card
                  hideChart
                  class="mb-base"
                  icon="VideoIcon"
                  :statistic="dvrsFirmwareVersion"
                  :statisticTitle="'DVRS_FIRMWARE_VERSION'"
                  color='success'  />
            </div>
        </div>

        <vx-card class="overflow-auto" :title="this.$t('VERSION_UPDATE_HISTORY')">
            <v-server-table id="version-update-table" ref="versionUpdateTable" name="versionUpdateTables"
                :columns="columns" :options="options" @loading="onLoading" @loaded="onLoaded">
                <vs-chip slot="device" slot-scope="props" :color="getDeviceColor(getDevice(props.row.reqValue))" class="w-full">
                {{$t(getDevice(props.row.reqValue))}}</vs-chip>
        </v-server-table>
         </vx-card>
    </div>

</template>

<script>
import VersionCard from './VersionCard.vue'
import moduleSystem from "@/store/system/moduleSystem.js"

export default{
    data() {
        return {

                // Table
                columns: ['adminId', 'methodName', 'device', 'version', 'createdDateTime'],
                options: {
                        perPage:10,
                        skin: 'table',
                        filterByColumn: true,
                        filterable: ['adminId', 'methodName','createdDateTime'],
                        sortable: ['adminId', 'methodName','createdDateTime'],
                        orderBy: { ascending: false },
                        debounce: 1000,
                        dateColumns:['createdDateTime'],
                        dateFormat: 'YYYY-MM-DD',
                        toMomentFormat: 'YYYYMMDD',
                        datepickerOptions: {
                            showDropdowns: true,
                            autoUpdateInput: true
                        },
                        sortIcon: {
                        base: 'feather',
                        up: 'icon-arrow-up',
                        down: 'icon-arrow-down',
                        },
                        texts:{
                            filterBy: this.$t("FILTER_BY"),
                            defaultOption: this.$t("DEFAULT_OPTION"),
                        },
                        headings: {
                        'adminId' : () => this.$t("ADMIN_ID"),
                        'methodName':  () => this.$t("ACTION"),
                        'device':  () => this.$t("UPDATE_DEVICE"),
                        'version' : () => this.$t("UPDATE_VERSION"),
                        'createdDateTime': () => this.$t("UPDATE_DATETIME")
                        },
                        listColumns:{
                            methodName:[
                                {
                                    id: 'updateAppVersion',
                                    text: this.$t("UPDATE_APP_VERSION")
                                },
                                {
                                    id: 'updateFirmwareVersion',
                                    text: this.$t("UPDATE_FIRMWARE_VERSION")
                                }
                            ],
                        },
                    requestAdapter: function(data) {

                        data.query.menuTitle="Version"
                        data.query.actionCode="U"

                        if(data.query.createdDateTime){
                            let localTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
                            let queryStart = moment.tz(data.query.createdDateTime.start, localTimeZone).format()
                            let queryEnd = moment.tz(data.query.createdDateTime.end, localTimeZone).format()

                            let start = moment(queryStart).utc().format('YYYY-MM-DD HH:mm:ss')
                            let end = moment(queryEnd).utc().format('YYYY-MM-DD HH:mm:ss')
                            
                            data.query.createdDateTime.start = start
                            data.query.createdDateTime.end = end
                        }

                        return {
                            ascending: data.ascending,
                            byColumn: data.byColumn,
                            pageSize: data.limit,
                            orderBy: data.orderBy ? data.orderBy : "createdDateTime",
                            page: data.page,
                            query: data.query,
                            pageResult: ((data.page-1)*data.limit)
                        };
                    },
                    requestFunction: function (data) {
                        return this.$http.get('/api/action-history/version-update', {
                                params: data
                        }).catch(function (e) {
                                this.dispatch('error', e);
                                this.$vs.loading.close()
                        }.bind(this));
                    },
                    responseAdapter: (response) => {
                        this.$store.commit('dataSystem/SET_UPDATE_VERSION_HISTORY',response.data)
                        return {
                            data: this.$store.state.dataSystem.versionUpdateHistory,
                            count: this.$store.state.dataSystem.versionUpdateHisotyCount
                        }
                    },
                    templates:{
                        methodName: function(h,row){
                            if(row.methodName == "updateAppVersion"){
                                return this.$t("UPDATE_APP_VERSION")
                            }else{
                                return this.$t("UPDATE_FIRMWARE_VERSION")
                            }
                        },
                        version: function(h,row){
                         
                            let deviceArray = row.reqValue.split('\n')
                            let device = JSON.parse(deviceArray[0])

                            if(typeof device.appVersion !== "undefined"){
                                return device.appVersion
                            }else if(typeof device.firmwareVersion !== "undefined"){
                                return device.firmwareVersion
                            }

                        },
                        createdDateTime: function(h,row){
                            let createdDateTime = row.createdDateTime
                            if(!createdDateTime){
                                return '-'
                            }else {
                                let localTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
                                let dateTime = this.$moment(createdDateTime,'YYYYMMDDHHmmss').format()
                                let dateTimeToLocal = this.$moment.tz(dateTime, localTimeZone).format('YYYY-MM-DD HH:mm:ss')
                            
                                return dateTimeToLocal
                            }
                        }
                    }
                }

        }
    },
    components: {
        VersionCard
    },
    mounted() {
    },
    created() {
        this.$vs.loading()
        if(!moduleSystem.isRegistered) {
            this.$store.registerModule('dataSystem', moduleSystem)
            moduleSystem.isRegistered = true
        }   
        this.$store.dispatch("dataSystem/fetchAppVersion")
        this.$store.dispatch("dataSystem/fetchFirmwareVersion").then(() =>{
                this.$vs.loading.close()
        })
    },
    computed:{
        androidAppVersion(){
            return this.$store.state.dataSystem.androidAppVersion
        },
        iosAppVersion(){
            return this.$store.state.dataSystem.iosAppVersion
        },
        dvrsFirmwareVersion(){
            return this.$store.state.dataSystem.dvrsFirmwareVersion
        }

    },
    methods: {
        getDevice(reqValue){
            let deviceArray = reqValue.split('\n')
            let device = JSON.parse(deviceArray[0])

            if(device.mobileCode==1){
                return "Android"
            }else if(device.mobileCode==2){
                return "iOS"
            }else if(device.seq==1){
                return "Firmware"
            }

        },
        getDeviceColor(device){
            if(device=="Android"){
                return "primary"
            }else if(device == "iOS"){
                return "danger"
            }else if(device=="Firmware"){
                return "success"
            }
            
        }
    },  
}
</script>

<style lang="scss">
#demo-basic-card {
    .overlay-card {
        .vx-card__collapsible-content {
            max-height: 485px;
        }
    }

    .chat-card-log {
        height: 360px;

        .chat-sent-msg {
            background-color: #f2f4f7 !important;
        }
    }

    .card-video {
        .video-js {
            height: 370px;
        }
    }
}

#version-update-table {
  text-align: center;
}
</style>

